import type { Locale } from "@/lib/i18n";
import { pl, type ThemeToggleTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const themeToggleTranslations: Record<Locale, ThemeToggleTranslations> = {
  pl,
  en,
  de,
};

export type { ThemeToggleTranslations };
